module.exports = __webpack_public_path__ + "public/img/zdyzhuti.aac206f9.png";